import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { RF_ANALYTICS } from '../../../../constants/apiRoutes';

/**
 * get RF Analytics .
 * @returns {Promise} - A promise that resolves with the list of RF Analytics or rejects with an error.
 * @param props
 */
export const getRFAnalytics = async ({
  moduleName,
  isServiceWorker,
  listController,
  data,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${RF_ANALYTICS}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
    body: data,
  });
  return response.Payload;
};

